<template>
  <v-card elevation="0" height="500" class="overflow-y-auto">
    <list-search
      v-if="search"
      @list:searching="searching"
      :label="searchLabel">
    </list-search>
    <v-list>
      <v-list-item-group color="primary">
        <v-list-item @click="ripChange">
          <v-list-item-icon>
            <v-icon
              class="anim"
              :class="{'anim_event': direction_down === false}">
              keyboard_arrow_down
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Tüm Gruplar</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <child-list
          v-if="direction && data"
          :children="data"
          @rip:child="ripChildChange">
        </child-list>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
import ChildList from './ChildList.vue';
import ListSearch from './ListSearch.vue';

export default {
  name: 'RootList',
  components: {
    ListSearch,
    ChildList,
  },
  props: {
    value: {
      type: Object,
      default: () => {
      },
      required: false,
    },
    items: {
      type: Array,
      default: () => [],
      required: false,
    },
    smart: {
      type: Boolean,
      default: false,
      required: false,
    },
    search: {
      type: Boolean,
      default: false,
      required: false,
    },
    searchLabel: {
      type: String,
      default: 'Search...',
      required: false,
    },
  },
  data: () => ({
    direction_down: true,
    data: [],
  }),
  methods: {
    ripChildChange($e) {
      this.$emit('rip:child', $e);
    },
    ripChange() {
      this.direction_down = !this.direction_down;
      if (this.items.length === 0) {
        this.$emit('rip:change');
      } else if (this.smart === false) {
        this.$emit('rip:change');
      }
    },
    searching(val = '') {
      this.data = this.items.filter(item => item.name.toLowerCase()
        .includes(val.toLowerCase()));
    },
  },
  computed: {
    direction() {
      return this.direction_down === false;
    },
  },
  watch: {
    items(nv) {
      this.data = nv;
    },
  },
};
</script>

<style scoped>
  .anim {
    transition: transform 0.2s ease-out;
  }

  .anim_event {
    transform: rotate(180deg);
  }
</style>
